<template>
  <div class="imgCarousel" :style="getCarouselStyle">
      <div :style="{ postion: 'relative' }">
        <div :style="getStyleImgMain">
          <!--iframe
            v-if="true"
            src="https://player.vimeo.com/video/" + + "?background=1&amp;title=0&amp;byline=0&amp;portrait=0"
            width="575"
            height="400"
            frameborder="0"
            allowfullscreen="allowfullscreen"
          ></iframe-->

          <div
            :style="{
              left: -getVideoOffset + 'px',
              position: 'absolute',
              background: '#000000ee',
            }"
          >
            <vueVimeoPlayer
              v-if="this.isVideo == 1"
              ref="player"
              :video-id="this.getVideoID()"
              loop="true"
              controls="true"
              :options="{ muted: 'false', t: '0s' }"
              :playerWidth="this.getVideoWidth"
              :playerHeight="this.getVideoHeight"
              autoplay="true"
            ></vueVimeoPlayer>

            <video
              v-if="this.isVideo == 2"
              ref="player"
              id="test"
              :src="this.getSelectedImg"
              class="introVideoC"
              :width="this.getVideoWidth"
              :height="this.getVideoHeight"
              muted
              loop
              autoplay="true"
            ></video>

            <!--vueVimeoPlayer
              ref="player"
              :video-id="this.pProject.titleVideo"
              loop="true"
              controls="false"
              :options="{muted: 'true', t: '3s'}"
              :playerWidth="this.getVideoWidth"
              :playerHeight="this.getVideoHeight"
              autoplay="false"
              @ready="onReady"
              @loaded="onLoaded"
              v-if="!this.pProject.introVideo"
            ></vueVimeoPlayer-->

          </div>

          <transition name="fade">
          <img
            v-if="this.isVideo == -1"
            v-bind:src="this.getSelectedImg()"
            :style="getStyleImgMain"
            class="imgMain"
            :key="findex"
          />
          </transition>

          <img
            src="/images/arrows_left.png"
            class="arrow_left"
            @click="selectLastImg()"
          />
          <img
            src="/images/arrows_right.png"
            class="arrow_right"
            @click="selectNextImg()"
          />

        </div>
        <div class="photoCaption">
          <span v-if="this.getCaption()">{{ this.getCaption() }}</span>
        </div>
      </div>
    <div class="imgThumbFrame">
      <div v-for="(_media, index) in this.pMediaArr" :key="index">
        <a
          @click="selectImg(index)"
          @mouseover="overIndex = index"
          @mouseleave="overIndex = -1"
        >
          <img
            v-bind:src="getThumbImg(_media)"
            :style="getStyleThumb(index)"
            class="thumbImg"
          />
          <img
            v-if="_media.vimeoID"
            src="/video.png"
            :style="getStyleThumb(index)"
            class="videoImg"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";

export default {
  components: { vueVimeoPlayer },
  data() {
    return {
      thumbMargin: 5,
      selectedMedia: null,
      selectedMediaIndex: 0,
      overIndex: -1,
      apiHost: "http://64.227.16.239:1337",

      findex: 0
    };
  },
  props: {
    pMediaArr: {
      type: Array,
    },
    pWidth: {
      type: Number,
      default: 1920, //1280,
    },
    pHeight: {
      type: Number,
      default: 1080, //720,
    },
    pThumbDiv: {
      type: Number,
      default: 1,
    },
  },
  computed: {

    isVideo: function () {

      console.log("* carousel start")
      //If this is from an object, get the media value
      //if (this.selectedMedia == null) {
      //  this.selectedMedia = this.pMediaArr[0];
      //}

      console.log(this.selectedMedia)

      if (this.selectedMedia.img) {

        console.log("* carousel " + this.selectedMedia.img)
  
        if (this.selectedMedia.vimeoID && this.selectedMedia.vimeoID != "") {
          console.log(this.selectedMedia.vimeoID);
          return 1;
        } else {
          return -1
        }
      } else if (!this.isImage(this.selectedMedia.url)) {
        return 2
      } else {
        return -1;
      }

    },

    getVideoOffset: function () {
      var _w = 0.5 * (this.getVideoWidth - this.pWidth);

      return _w;
    },
    getCarouselStyle: function () {
      var _totalRows = Math.floor(this.pMediaArr.length / this.pThumbDiv);

      if (this.pMediaArr.length % this.pThumbDiv > 0) {
        _totalRows++;
      }

      return {
        width: this.pWidth + "px",
        height: this.pHeight + _totalRows * this.thumbSize + 40 + "px",
      };
    },
    thumbSize: function () {
      var _t = this.pWidth / this.pThumbDiv;
      return _t - ((this.pThumbDiv - 1) * this.thumbMargin) / this.pThumbDiv;
    },
    getStyleImgMain: function () {
      return {
        width: this.pWidth + "px",
        height: this.pHeight + "px",
        position: "relative",
        overflow: "hidden",
        background: "#000000ee"
      };
    },
    getVideoWidth: function () {
      return (this.pHeight * 1280) / 720; //(this.pWidth * 720) / 1280;
    },
    getVideoHeight: function () {
      return this.pHeight; //(this.pWidth * 720) / 1280;
    },
  },
  methods: {

    selectLastImg: function () {
      this.selectedMediaIndex = 
        this.selectedMediaIndex > 0 ? this.selectedMediaIndex - 1 : this.pMediaArr.length - 1
      this.selectedMedia = this.pMediaArr[this.selectedMediaIndex];

      this.findex++
    },

    selectNextImg: function () {
      this.selectedMediaIndex = 
        this.selectedMediaIndex < this.pMediaArr.length - 1 ? this.selectedMediaIndex + 1 : 0

      this.selectedMedia = this.pMediaArr[this.selectedMediaIndex];

      this.findex++
    },

    getExtension: function(filename) {
      var parts = filename.split('.');
      return parts[parts.length - 1];
    },

    isImage: function(filename) {

      console.log(filename)
      var ext = this.getExtension(filename);
  
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'bmp':
        case 'png':
          //etc
          return true;
      }
      return false;
    },

    getVideoID: function () {
      //if (this.selectedMedia == null) {
      //  this.selectedMedia = this.pMediaArr[0];
      //}
      if (this.selectedMedia.vimeoID) {
        return this.selectedMedia.vimeoID;
      }
      return 0;
    },
    selectImg: function (_index) {
      this.selectedMediaIndex = _index;
      this.selectedMedia = this.pMediaArr[_index];
    },
    getCaption: function () {
      //if (this.selectedMedia == null) {
      //  this.selectedMedia = this.pMediaArr[0];
      //}

      if (this.selectedMedia.caption) {
        return this.selectedMedia.caption;
      } else {
        return "";
      }
    },
    getSelectedImg: function () {
      if (this.selectedMedia == null) {
        this.selectedMedia = this.pMediaArr[0];
      }

      if (this.selectedMedia.img) {
        return this.apiHost + this.selectedMedia.img.url;
      } else {
        return this.apiHost + this.selectedMedia.url;
      }
    },
    getThumbImg: function (_media) {
      var _u;

      if (_media.img) {
        _media = _media.img;
      }

      if (_media.formats && _media.formats.thumbnail) {
        _u = this.apiHost + _media.formats.thumbnail.url;
      } else {
        _u = _media.url;
      }

      //console.log("thumb : " + _u);
      return _u;
    },
    getStyleThumb: function (_index) {
      var _row = Math.floor(_index / this.pThumbDiv);
      var _col = Math.floor(_index % this.pThumbDiv);

      var _defaultOver = _index == this.overIndex ? 1.0 : 0.7;

      var _s = {
        left:
          _col * this.thumbSize +
          (_col > 0 ? _col : 0) * this.thumbMargin +
          "px",
        top:
          _row * this.thumbSize +
          (_row > 0 ? _row : 0) * this.thumbMargin +
          "px",
        width: this.thumbSize + "px",
        height: this.thumbSize + "px",
        border:
          _index == this.selectedMediaIndex
            ? "solid 2px #eeee00"
            : "solid 2px #33333300",
        opacity: _index == this.selectedMediaIndex ? 1.0 : _defaultOver,
      };
      
      //console.log(_index);
      //console.log(_s);
      
      return _s;
    },
  },
  created() {
    console.log("^^^^^^^^ MEDIA ARR");
    console.log(this.pMediaArr);

    if (this.selectedMedia == null) {
        this.selectedMedia = this.pMediaArr[0];
    }
  },
};
</script>

<style>

.photoCaption {
  height: 20px;
  position: relative;
  font-size: 12px;
}

.imgCarousel {
  position: relative;
}

.imgThumbFrame {
  top: 5px;
  left: -2px;
  position: relative;
}

.imgMain {
  margin: auto;
  display: block;
  background: #000000ee;
  object-fit: contain;
}

.thumbImg {
  object-fit: cover;
  position: absolute;
}

.videoImg {
  object-fit: cover;
  position: absolute;
  left: 0px;
  top: 0px;
}

.thumbImg a:hover {
  opacity: 1;
}


.arrow_left {
  position: absolute;
  left: 20px;
  top: 47%;
}

.arrow_right {
  position: absolute;
  right: 20px;
  top: 47%;
}

</style>